import { Component } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { BaseTableComponent } from '../../shared/base/base-table.component';
import { Adjuster } from '../../models/adjuster-management.model';
import { AdjusterManagementService } from '../../services/adjuster-management.service';
import { openDeleteConfirmationDialog } from '../../shared/utils/confirm-dialog.utils';
import { formatHttpErrorMessage } from '../../shared/utils/error.utils';

@Component({
  selector: 'app-adjuster-management',
  standalone: false,
  templateUrl: './adjuster-management.component.html',
  styleUrls: ['./adjuster-management.component.css']
})
export class AdjusterManagementComponent extends BaseTableComponent<Adjuster> {

  override sortBy = 'lastName';
  override sortDir: 'asc' | 'desc' = 'asc';

  readonly displayedColumns: string[] = [
    'firstName',
    'lastName',
    'email',
    'adjusterKey',
    'userName',
    'telephone',
    'office',
    'team',
    'delete'
  ];

  filter = {
    firstName: '',
    lastName: '',
    userName: '',
    email: ''
  };

  constructor(
    private adjusterManagementService: AdjusterManagementService,
    private dialog: MatDialog
  ) {
    super();
  }

  protected override loadData(skip: number, count: number): void {

    this.loading = true;

    this.adjusterManagementService
      .getAdjusters(
        skip,
        count,
        this.sortBy,
        this.sortDir,
        this.filter
      )
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (response) => {
          this.dataSource.data = response.adjusters;
          this.totalCount = response.totalCount;
          this.errorMessage = '';
        },
        error: (err) => {
          this.errorMessage = formatHttpErrorMessage('Failed to load adjusters', err);
          this.dataSource.data = [];
          this.totalCount = 0;
        }
      });
  }

  onFilter(): void {
    this.pageIndex = 0;
    this.loadDataWrapper();
  }

  onDelete(record: Adjuster): void {

    const dialogRef = openDeleteConfirmationDialog(
      this.dialog,
      'Delete Adjuster',
      `Are you sure you want to delete adjuster "${record.office} -${record.team}"?`
    );

    dialogRef.afterClosed().subscribe(confirmed => {

      if (!confirmed) return;

      this.loading = true;

      this.adjusterManagementService
        .deleteAdjuster(record.adjusterID)
        .pipe(finalize(() => (this.loading = false)))
        .subscribe({
          next: () => this.loadDataWrapper(),
          error: (err) => {
            this.errorMessage = formatHttpErrorMessage('Failed to delete adjuster', err);
          }
        });
    });
  }
}